/**
 * Gemeinsame Logik für Einsatztermine (Slots).
 *
 * Ein Slot ist ein Wert-Snapshot (keine ID!):
 *   { date: 'YYYY-MM-DD', timeFrom: 'HH:MM'|null, timeUntil: 'HH:MM'|null, label: string|null }
 *
 * timeFrom/timeUntil sind immer BEIDE oder KEINE gesetzt.
 * timeUntil <= timeFrom bedeutet "endet am Folgetag" (Nachtschicht) – das ist gültig, kein Fehler.
 *
 * Nutzt this.$dayjs (via @nuxtjs/dayjs, defaultLocale 'de') und this.$t.
 */
export default {
  methods: {
    // Eindeutiger Schlüssel aus dem Slot-Wert (es gibt keine Slot-ID).
    slotKey(slot) {
      return [
        slot.date,
        slot.timeFrom || '',
        slot.timeUntil || '',
        slot.label || '',
      ].join('__');
    },
    // Nachtschicht: Endzeit liegt am/vor der Startzeit -> endet am Folgetag.
    isSlotOvernight(slot) {
      return !!(
        slot.timeFrom &&
        slot.timeUntil &&
        slot.timeUntil <= slot.timeFrom
      );
    },
    // Liegt der Termin (kalendarisch) vor heute?
    isSlotPast(slot) {
      if (!slot || !slot.date) {
        return false;
      }
      return this.$dayjs(slot.date).isBefore(
        this.$dayjs().startOf('day'),
        'day'
      );
    },
    // Zur Auswahl anbietbar sind nur zukünftige Termine (inkl. heute).
    isSlotSelectable(slot) {
      return !this.isSlotPast(slot);
    },
    // Chronologisch sortiert (Datum, dann Startzeit). Kopie, mutiert die Quelle nicht.
    sortSlots(slots) {
      return [...(slots || [])].sort((a, b) => {
        if (a.date !== b.date) {
          return a.date < b.date ? -1 : 1;
        }
        const aFrom = a.timeFrom || '';
        const bFrom = b.timeFrom || '';
        if (aFrom === bFrom) {
          return 0;
        }
        return aFrom < bFrom ? -1 : 1;
      });
    },
    // z.B. "Fr, 15.08.2026 · 09:00–17:00 Uhr · Messetag 1"
    //      "Fr, 15.08.2026 · ganztägig"
    //      "Fr, 15.08.2026 · 22:00–06:00 Uhr (endet am Folgetag) · Nachtschicht"
    formatSlot(slot) {
      if (!slot || !slot.date) {
        return '';
      }
      const parts = [this.$dayjs(slot.date).format('dd, DD.MM.YYYY')];
      if (slot.timeFrom && slot.timeUntil) {
        let time = `${slot.timeFrom}–${slot.timeUntil} ${this.$t(
          'availability_slot.oclock'
        )}`;
        if (this.isSlotOvernight(slot)) {
          time += ` ${this.$t('availability_slot.overnight')}`;
        }
        parts.push(time);
      } else {
        parts.push(this.$t('availability_slot.all_day'));
      }
      if (slot.label) {
        parts.push(slot.label);
      }
      return parts.join(' · ');
    },
  },
};
